import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { Input, Button, Breadcrumbs } from '../../../../components/UI/ComponentsUI';
import { translate, showMessageToastCustom } from '../../../../utils/util';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import StockService from '../../../../services/StockService';

const InsertMailer = (props) => {
    const update = props.location?.state?.update;
    const formType = props.location?.state?.formType;
    const [mailer, setMailer] = useState(update && props.mailer ? props.mailer :
        { name: '', email: '', formType: formType });

    const onConfirm = () => {
        if (validateInputsRequired('formMailer')) {
            if (update) {
                props.editMailer(mailer, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        props.history.go(-1);
                    }
                });
            }
            else {
                props.addMailer(mailer, (response) => {
                    if (!response) {
                        showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        props.history.go(-1);
                    }
                });
            }
        }
    };

    const onChange = (event) => {
        onValueChange(event, mailer, setMailer);
    };

    return (
        <div>
            <Breadcrumbs id="pickinginvoice" title={{
                icon: "mdi mdi-email-plus-outline", label: update ? translate('edit-email', 'stock') : translate('add-email', 'stock')
            }} />
            <div className="container-fluid" style={{ marginTop: '25px', }
            } >
                <div className='container'>
                    <div className='card'>
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div id="formMailer" className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        value={mailer?.name || ''}
                                        type="text"
                                        label={translate('name', 'stock')}
                                        id="name"
                                        name='name'
                                        maxLength="100"
                                        onChange={onChange}
                                        required
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        label={translate('stock:form.email')}
                                        id="email"
                                        name='email'
                                        onChange={onChange}
                                        value={mailer?.email || ''}
                                        maxLength="100"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ marginTop: '20px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

const mapStateToProps = (state) => {
    return {
        mailer: state.stockReducer.mailer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addMailer: (mailer, callback) => {
            dispatch(StockService.addMailer(mailer, callback));
        },
        editMailer: (mailer, callback) => {
            dispatch(StockService.editMailer(mailer, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(InsertMailer)));